<template>
  <section id="certificates">
    <v-carousel fill-height height="100vh">
       <v-carousel-item v-for="({ icon, color,title, text }, i) in certificates" :key="i">
        <v-sheet :color="color" height="100%" tile>
          <div class="py-12"></div>
          <v-row align="center" justify="center" class="my-3">
            <v-img contain :src="icon" height="150" max-width="90%"></v-img>
          </v-row>
          <div class="py-12"></div>
          <v-responsive class="mx-auto title font-weight-light mb-8 certificatesTextContainer" >
            <div class="title black--text text-center" v-text="title"></div>
            <div class=" font-weight-light black--text text-center certificatesText" v-html="$t(text)"></div>
          </v-responsive>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </section>
</template>


<script>
export default {
  name: "Certificates",
  data: () => {
    return {
      certificates: [
        {
          icon: require("../assets/scrumorg.png"),
          color: "secondary",
          title: "Professional SCRUM Master",
          text: 'certificatesSCRUM',
        },
        {
          icon: require("../assets/itil.png"),
          color: "white",
          title: "ITIL Service Manager",
          text: 'certificatesITIL',
        },
        {
          icon: require("../assets/ipma.png"),
          color: "secondary",
          title: "Project Manager",
          text: 'certificatesIPMA',
        },
        {
          icon: require("../assets/gpm.png"),
          color: "third",
          title: "Process Manager",
          text: 'certificatesPM',
        },
      ]
    };
  }
};
</script>

<style>
.v-carousel__controls{
  background: white !important
}
.v-carousel__controls__item{
  color:#080ed5 !important
}
</style>
<style scoped>
.certificatesText {
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: .009375em
}
.certificatesTextContainer {
  max-width: 60%;
  alignment: center;
}
@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .certificatesTextContainer {
    max-width: 90%;
  }
}
</style>